import { FC, useEffect } from "react";
import { Flex, Theme } from "@radix-ui/themes";
import useDocumentTitle from "@/hooks/useDocumentTitle";
import { useParams } from "react-router-dom";
import { Loader } from "@/components";
import useSetClient from "@/hooks/useSetClient";
import { ChallengeOverview } from "@/features/challenge/components/overview/ChallengeOverview.fetcher";
import { themeMap, themeRadiusMap } from "@/utils/constants/Themes";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";

const ChallengesPage: FC = (): JSX.Element => {
  const { slug } = useParams();
  useDocumentTitle("Events");

  const { zoneItem, loadingZone: loading } = useSetClient(slug);

  const theme =
    themeMap[zoneItem?.theme.toUpperCase()] ||
    themeMap[brand.brandTheme.toUpperCase()] ||
    "violet";
  const radius = themeRadiusMap[zoneItem?.theme.toUpperCase()] || "none";

  if (loading) {
    return <Loader />;
  }

  if (slug) {
    return (
      <Theme appearance="dark" accentColor={theme} radius={radius}>
        <ChallengeOverview zone={zoneItem} />
      </Theme>
    );
  }

  return <ChallengeOverview />;
};

export default ChallengesPage;
